import React from 'react';
import styled from 'styled-components';
import ComponentStyles from '../brand-styles/components/FilterButton.styles';
import { colors } from '../style-utilities/variables';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSlidersH} from '@fortawesome/free-solid-svg-icons';

const Button = styled.button`
  border: none;
  background: ${colors.primary};
  color: white;
  svg {
    height: 20px;
    width: 30px;
  }
  /* Dynamic brand styles */
  ${ComponentStyles}
`;

const FilterButton = ({ filterToggle, children, ...remainProps }) => {
  return (
    <Button {...remainProps} onClick={filterToggle}>
       <FontAwesomeIcon icon={faSlidersH} /> Filter
    </Button>
  );
};

export default FilterButton;
